class MarqueeWheel extends HTMLElement {
  connectedCallback() {
    this.tiles = this.querySelectorAll('.marquee-wheel-tile');
    this.allVideos = [];
    this.visible = true;
    this.observer = null;
    this.initTiles();
    this.initVisibility();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.allVideos.forEach((v) => {
      if (!v.paused) {
        v.pause();
      }
    });
  }

  initTiles() {
    this.tiles.forEach((tile) => {
      const video = tile.querySelector('video');
      const canvas = tile.querySelector('canvas');
      if (!video || !canvas) {
        return;
      }
      this.allVideos.push(video);

      const ctx = canvas.getContext('2d', { alpha: false });

      const sizeCanvas = () => {
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 320;
      };

      if (video.readyState >= 1) {
        sizeCanvas();
      } else {
        video.addEventListener('loadedmetadata', sizeCanvas, { once: true });
      }

      video.play().catch(() => {});

      const paint = () => {
        if (this.visible && video.readyState >= 2) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
        video.requestVideoFrameCallback(paint);
      };

      video.requestVideoFrameCallback(paint);
    });
  }

  initVisibility() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries[0].isIntersecting;
      this.tiles.forEach((t) => {
        t.style.animationPlayState = this.visible ? 'running' : 'paused';
      });
      this.allVideos.forEach((v) => {
        if (this.visible && v.paused) {
          v.play().catch(() => {});
        } else if (!this.visible && !v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.1 });

    this.observer.observe(this);
  }
}

if (!customElements.get('marquee-wheel')) {
  customElements.define('marquee-wheel', MarqueeWheel);
}
